// Exhausted provisions are historical records, not inventory. Reusable vessels
// remain items even when their legacy provision quantity or fill reaches zero.
const isDepletedProvision = item => {
  if (!item || item.idContainer || item.container || item.containerName
    || String(item.itemType || '').toLowerCase() === 'container') return false;
  const provision = String(item.itemType || '').toLowerCase() === 'provision'
    || item.idProvisionMaterial || item.provisionMaterial || item.provisionMaterialName;
  const quantity = item.quantity ?? item.provisionQuantity;
  return Boolean(provision && quantity != null && String(quantity).trim() !== ''
    && Number.isFinite(Number(quantity)) && Number(quantity) <= 0);
};

module.exports = { isDepletedProvision };
